module.exports = "## Refresh Indicator\nThe [refresh indicator](https://www.google.com/design/spec/components/progress-activity.html#)\nis used when showing an item is loading. It is kept hidden from the interface until it's\nstatus prop is changed to `loading` or `ready`.\n\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/RefreshIndicator/README.md
 ** module id = 1039
 ** module chunks = 0
 **/